import { render } from "./DxtAccountStatistics.vue?vue&type=template&id=b07fa31e&scoped=true"
import script from "./DxtAccountStatistics.vue?vue&type=script&lang=js"
export * from "./DxtAccountStatistics.vue?vue&type=script&lang=js"

import "./DxtAccountStatistics.vue?vue&type=style&index=0&id=b07fa31e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b07fa31e"

export default script